<template>
  <!--
      	作者：long
      	时间：2023-08-21
      	描述：插件中心-问卷调查
      -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="问卷记录" name="record"></el-tab-pane>
      <el-tab-pane label="问卷模板" name="template"></el-tab-pane>
      <el-tab-pane label="问卷白名单" name="user"></el-tab-pane>
    </el-tabs>

    <!--抽奖记录-->
    <Record v-if="activeName == 'record'"></Record>
    <!-- 问卷模板 -->
    <Template v-if="activeName == 'template'"></Template>
    <!-- 问卷白名单 -->
    <User v-if="activeName == 'user'"></User>

  </div>
</template>
<script>
  import Record from './record.vue';
  import Template from './template.vue';
  import User from './user.vue';
  
  export default {
    components: {
      Record,
      Template,
      User,
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        activeName: 'record'
      };
    },
    methods: {}
  };
</script>

<style>
  .operation-wrap {
    height: 124px;
    border-radius: 8px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 30px 30px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: hidden;
    background: #909399;
    background-size: 100% 100%;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/quesire/index.vue